const desserts = [
  {
    id: 1,
    name: "Gulab Jabun",
    description: "2 Pcs",
    price: "£3.85"
  },
  {
    id: 2,
    name: "Gajar Halwa",
    price: "£3.85"
  }
];

export default desserts;